/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import TafNetwork from '@huyafed/taf-network';
import Avatar from './jce/GameLiveBase';
import HUYA from './jce/FriendFissionServant';
import CheckBalance from './jce/WalletServant';
import { LiveRedirect } from './jce/WebLiveRedirectServer';
import { HYLogin, HYDevice, HYUserInfo } from '@hy-hybrid/kiwi-js-sdk';
import store from './toolkit';
import { setLogin, setUid } from './toolkit/base';
import Mock from 'mockjs';
import { getCookie } from './utils';
// import VConsole from 'vconsole';
// if (/pref-|test-/g.test(location.href)) {
//   new VConsole();
// }
const Random = Mock.Random;
const pullData = () => {
  const data: any = [];
  for (let i = 0; i < 6;) {
    data.push({
      iStatus: Random.natural(0, 2),
      sNickName: Random.name(),
      sAvatarUrl: Random.image(),
      iInvedType: Random.natural(0, 2),
      lInvedTime: Random.date(),
      tAward: {
        lCash: Random.boolean() ? Random.natural(1, 2000) : 0,
        lValue: Random.boolean() ? Random.natural(1, 2000) : 0,
      },
    });
    i += 1;
  }
  return data;
};
// declare const HUYA: any
class Serve {
  sdk: any;
  isDebug: boolean;
  appInfo: any;
  userInfo: any;
  tId: any;
  sendWup: any;
  constructor() {
    const { isDebug, isApp } = store.getState().base;
    this.appInfo = null;
    this.userInfo = null;
    this.tId = new HUYA.UserId();
    // mockId
    // this.tId.lUid = 1199513154080
    this.sdk = new TafNetwork({
      showLog: true,
      isDebug,
      // isApp: process.env.NODE_ENV != 'development',
      isApp,
    });
    this.sendWup = (...payload) =>
      new Promise((resolve) => {
        this.sdk.sendWup(...payload).then((rsp) => {
          if (rsp.bcode === 0 && rsp.sdkcode === 0) {
            resolve({
              code: 0,
              data: rsp.data,
            });
          } else {
            resolve({
              code: -1,
              data: rsp.data,
            });
          }
        });
      });
    this.sdkInit().then((rsp) => {
      store.dispatch(setLogin(rsp));
      if (rsp) {
        store.dispatch(setUid(this.userInfo.uid));
      }
    });
  }
  async sdkInit() {
    // if (process.env.NODE_ENV == 'development') {
    //   this.appInfo = {
    //     systemVersion: '15.6',
    //     experiment:
    //       '6737.9911,6773.9963,8062.11896,8351.12352,8578.12694,8666.12809,8852.13067,11423.17084,11745.17615,12979.19670,12985.19678,14009.21295,15383.23487,17382.26602,17397.26608,17466.26723,17532.26824,17783.27216,18131.27751,18414.28181,18488.28312,18553.28405,18625.28547,18667.28616,18738.28739,18741.28741,18742.28746,18775.28796,18800.28831,18803.28834,18806.28843,18835.28893,18860.28940,18864.28953,18885.28989',
    //     appName: 'kiwi-ios',
    //     appVersion: '10.1.240',
    //     huyaUA: 'ios&10.1.240&store&15.6',
    //     privilegeUseIAP: false,
    //   };
    //   this.userInfo = {
    //     sign: '',
    //     udbToken:
    //       '4QDfAAEDAAAATyj7AgAAAAAAAAxbjKWCAQQANTAxMCQAQjY4REIzRjUtQTM4RS00M0M1LUIyNzQtRjcxOTQ4NDE1QzFBBAA1MDEwkgACFf9TkrM7I7n13X1yfi17quOAkNR89QHG%2F0xRS%2BgyFtKLBMmolGLJlcabnsPVvf0J9Xz3CttYeokgBgK2koFsHeRt5y%2F3VUFa4htUNKksGNuK%2BGBCzYpJyx%2BeXKzLEkYdhIh4V2SjhYeO6CageFumkgURzG4L%2FhjR9z%2BeGl3Hq7Iay5qrOAXCY0vK%2Fz0%2BlDzYpAAAAAA%3D',
    //     nobleInfo: {
    //       uid: 50014287,
    //       validDate: 0,
    //       isNoble: false,
    //       nobleLevel: 0,
    //       channelInfo: {
    //         isFans: false,
    //         guardLevel: 0,
    //         fansLevel: 0,
    //         isGuard: false,
    //         highestGuardLevel: 0,
    //         sid: 0,
    //         tid: 0,
    //         pid: 0,
    //       },
    //       nobleNick: '虎牙-方阳-前端',
    //       nobleName: '',
    //     },
    //     uid: 50014287,
    //     sex: '男',
    //     bindPhone: true,
    //     isThirdPartyLogin: false,
    //     userCurrentExp: 829497,
    //     logoUrl:
    //       'https://test-huyaimg.msstatic.com/avatar/1083/bc/2427f2d083beb73609412f5b321e6c_180_135.jpg?1615357586',
    //     avatarUrl:
    //       'https://test-huyaimg.msstatic.com/avatar/1083/bc/2427f2d083beb73609412f5b321e6c_180_135.jpg?1615357586',
    //     passport: 'dw_fangyang1',
    //     isLoggedIn: true,
    //     userLevel: 59,
    //     ticketType: '2',
    //     imid: 909013287,
    //     dailyExp: 0,
    //     nextLevelExp: 860600,
    //     name: '虎牙-方阳-前端',
    //   };
    //   const isLogin = !!getCookie('udb_uid');
    //   this.tId.lUid = isLogin ? this.userInfo.uid : 0;
    //   this.tId.sToken = isLogin ? this.userInfo.udbToken : '';

    //   this.tId.sCookie = isLogin ? getCookie('udb_biztoken') : '';
    //   this.tId.sHuYaUA = this.appInfo.huyaUA;
    //   this.tId.sDeviceInfo = JSON.stringify(this.appInfo);
    // } else {
    const promises = [
      new Promise((resolve) => {
        HYLogin.isLogin({}).then((resp) => {
          console.log('登录状态', resp);
          resolve(!!resp.isLogin);
        });
      }),
      new Promise((resolve) => {
        HYDevice.getAppInfo({}).then((resp) => {
          console.log('设备信息', resp);
          resolve(resp);
        });
      }),
      new Promise((resolve) => {
        HYUserInfo.getCurrentUserInfo({}).then((resp) => {
          console.log('用户信息', resp);
          resolve(resp);
        });
      }),
    ];
    const [isLogin, appInfo, userInfo]: any[] = await Promise.all(promises);
    this.appInfo = appInfo;
    console.log('this.appInfo: ', this.appInfo);

    this.userInfo = userInfo;
    console.log('this.userInfo: ', this.userInfo);
    this.tId.lUid = isLogin ? userInfo.uid : 0;
    this.tId.sToken = isLogin ? userInfo.udbToken : '';

    this.tId.sCookie = isLogin ? getCookie('udb_biztoken') : '';
    this.tId.sHuYaUA = appInfo.huyaUA;
    this.tId.sDeviceInfo = JSON.stringify(appInfo);
    // }
    return true;
  }
  getInvitationInfo(iStart = 0, iCount = 5000) {
    console.log('getInvitationInfo', iStart, iCount);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          code: 0,
          data: {
            iReturnCode: 0,
            iInvCount: 123,
            vInvedUserStatus: { value: [] },
            mInved: {
              value: {
                0: 1,
                1: 2,
                2: 3,
              },
            },
            iInvedType: 1,
            tTotal: {
              mItems: {
                value: {
                  8: 100,
                  4: 2000,
                },
              },
              lExp: 100,
              lPoint: 10,
              lCash: 101,
              lValue: 10,
              lAwardTime: 0,
              sReason: '',
            },
            lStartTime: 1636102813,
            lEndTime: 1636707612,
            iToast: 1,
            mInvCode: {
              value: {
                0: 123,
                1: 456,
                2: 789,
                3: 101,
              },
            },
          },
        });
      }, 1500);
    });
  }
  getInvitationDetail(iStart = 0, iCount = 0) {
    console.log('getInvitationDetail', iStart, iCount);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          code: 0,
          data: {
            iReturnCode: 0,
            iInvCount: Random.natural(0, 50),
            newTotal: 30,
            vDetail: { value: pullData() },
            tTotal: {
              mItems: {
                value: {
                  8: 100,
                  4: 2000,
                },
              },
              lExp: 100,
              lPoint: 10,
              lCash: Random.natural(0, 200),
              lValue: Random.natural(0, 200),
              lAwardTime: 0,
              sReason: '',
            },
          },
        });
      }, 2000);
    });
  }
  getUserProfile(lUid = 0) {
    return this.sendWup(
      'getUserProfile',
      {
        lUid,
      },
      Avatar.GetUserProfileReq,
      Avatar.GetUserProfileRsp,
      'huyauserui',
      { iResult: 1 }
    );
  }
  getFriendInvitationInfo(flag, iStart = 0, iCount = 1000) {
    return this.sendWup(
      'getFriendInvitationInfo',
      {
        tId: this.tId,
        iStart,
        iCount,
        iIsUpdateOpenPageTime: flag,
      },
      HUYA.FissionInvitationInfoReq,
      HUYA.FissionInvitationInfoRsp,
      'wupui',
      {
        iReturnCode: 0,
        iInvedType: 0,
        iToast: 1,
        iInvCount: 3,
        mInved: {
          value: { 1: 0, 2: 0, 3: 0 },
        },
      }
    );
  }
  getOld(lUid) {
    const tId = new HUYA.UserId();
    tId.lUid = lUid;
    return this.sendWup(
      'getFriendInvitationInfo',
      {
        tId,
        iStart: 0,
        iCount: 0,
      },
      HUYA.FissionInvitationInfoReq,
      HUYA.FissionInvitationInfoRsp,
      'wupui',
      {
        iReturnCode: 0,
        iInvedType: 0,
        iToast: 1,
        iInvCount: 3,
        mInved: {
          value: { 1: 0, 2: 0, 3: 0 },
        },
      }
    );
  }
  getFriendInvitationDetail(iStart = 0, iCount = 0, iShowType = 0) {
    return this.sendWup(
      'getFriendInvitationDetail',
      {
        tId: this.tId,
        iStart,
        iCount,
        iShowType,
      },
      HUYA.FissionInvitationDetailReq,
      HUYA.FissionInvitationDetailRsp,
      'wupui'
    );
  }
  checkBalance() {
    return this.sendWup(
      'checkBalance',
      {
        tId: this.tId,
      },
      CheckBalance.CheckBalanceReq,
      CheckBalance.CheckBalanceRsp,
      'wupui'
    );
  }
  getFriendInvCode() {
    return this.sendWup(
      'getFriendInvCode',
      {
        tId: this.tId,
      },
      HUYA.FissionInvCodeReq,
      HUYA.FissionInvCodeRsp,
      'wupui'
    );
  }
  getShortUrl(parm) {
    return this.sendWup(
      'getShareShortLink',
      parm,
      LiveRedirect.GetShareShortLinkReq,
      LiveRedirect.GetShareShortLinkResp,
      'webLiveUI'
    );
  }
}
export default new Serve();
